@let data = dialogData();
<table class='pro-table pro-table-with-labels w-100 m-0'>
	<tr>
		<td>Name</td>
		<td>{{data.personFullName}}</td>
	</tr>
	<tr>
		<td>Venture</td>
		<td><a class="link-primary" (click)="openVentureDetails()">{{data.ventureName}}</a></td>
	</tr>
	<tr>
		<td>Phase</td>
		<td>{{data.userRolePhase}}</td>
	</tr>
	<tr>
		<td>Trimester</td>
		<td>{{data.trimesterName}}</td>
	</tr>
	<tr>
		<td>Type</td>
		<td>{{data.promptType}}</td>
	</tr>
	<tr>
		<td>Author</td>
		<td>{{data.promptAuthor}}</td>
	</tr>
	<tr>
		<td>Date</td>
		<td>{{formattedDate()}}</td>
	</tr>
</table>

@if(data.responseDetails; as responseDetails){
<table class='pro-table pro-table-with-labels w-100 m-0 mt-3'>
	<tr>
		<td>Language Detected</td>
		<td>{{responseDetails.languageDetected}}</td>
	</tr>
	<tr>
		<td>Topic Detected</td>
		<td>{{responseDetails.topicDetected}}</td>
	</tr>
	<tr>
		<td>Intent Detected</td>
		<td>{{responseDetails.intentDetected}}</td>
	</tr>
	<tr>
		<td>Entrepreneurial</td>
		<td>{{responseDetails.isPromptEntrepreneurial}}</td>
	</tr>
	<tr>
		<td>Thumb Rating</td>
		<td>{{responseDetails.rating}}</td>
	</tr>
	<tr>
		<td>Suggested Next Prompt</td>
		<td>{{responseDetails.suggestedNextPrompt}}</td>
	</tr>
</table>
}@else {
<table class='pro-table pro-table-with-labels w-100 m-0 mt-3'>
	<tr>
		<td>Blocked Reason</td>
		<td>{{data.blockedReason}}</td>
	</tr>
	<tr>
		<td>Blocked Message</td>
		<td>{{data.blockedMessage}}</td>
	</tr>
	<tr>
		<td>Error</td>
		<td>{{data.error}}</td>
	</tr>
</table>
}